import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { PaginationResponse, ResponseData } from "./types/_public";
import { IDomain } from "./types/_domain";
const api = new APIClient();

const path = '/domains';
const domainApi = {
    domains(params: any): Promise<AxiosResponse<ResponseData<IDomain[]> & PaginationResponse, any>> {
        const url = `${path}`
        return api.get(url, params)
    },
    allDomains(params: any = {}): Promise<AxiosResponse<ResponseData<IDomain[]>, any>> {
        const url = `/masters/domains`;
        return api.get(url, params)
    },
    getDomain(id: string | number, params: any = {}): Promise<AxiosResponse<ResponseData<IDomain>, any>> {
        const url = `${path}/${id}`;
        return api.get(url, params)
    },
    postDomain(dataForm: any): Promise<AxiosResponse<ResponseData<IDomain>, any>> {
        const url = `${path}`;
        return api.post(url, dataForm)
    },
    putDomain(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IDomain>, any>> {
        const url = `${path}/${id}`;
        return api.put(url, dataForm)
    },
    deleteDomain(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IDomain>, any>> {
        const url = `${path}/${id}`;
        return api.delete(url, dataForm)
    },

}
export default domainApi
